import React from 'react';
import { FormulaComponentProps } from '../../types/index';
import { INFERRED_SOURCES } from '../../constants';
import { MathMLRenderer, createMathML } from '../shared/MathMLRenderer';
import { WeightTable } from '../shared/WeightTable';

export const GdaScoreInferred: React.FC<FormulaComponentProps> = ({ className, style }) => {
  const sourcesText = INFERRED_SOURCES.join(', ');
  
  const introMath = createMathML(`
    <mrow>
      <mtext>The set I of INFERRED sources is defined as:</mtext>
    </mrow>
  `, 'inline');

  const setDefinition = createMathML(`
    <mrow>
      <mi>I</mi>
      <mo>=</mo>
      <mo stretchy="true" form="prefix">&#123;</mo>
      <mrow>
        <mi>${sourcesText}</mi>
      </mrow>
      <mo stretchy="true" form="postfix">&#125;</mo>
    </mrow>
  `);

  const subsetDefinition = createMathML(`
    <mrow>
      <mtext>Given a subset</mtext>
      <mspace width="0.222em" />
      <msub>
        <mi>S</mi>
        <mrow>
          <mi mathvariant="italic">I</mi>
        </mrow>
      </msub>
      <mo>,</mo>
      <mspace width="0.222em" />
      <msub>
        <mi>S</mi>
        <mrow>
          <mi mathvariant="italic">I</mi>
        </mrow>
      </msub>
      <mspace width="0.222em" />
      <mo>⊆</mo>
      <mspace width="0.222em" />
      <mo>I,</mo>
      <mspace width="0.222em" />
      <msub>
        <mi>W</mi>
        <mrow>
          <mi mathvariant="italic">I</mi>
        </mrow>
      </msub>
      <mspace width="0.222em" />
      <mtext>is defined as:</mtext>
    </mrow>
  `, 'inline');

  const weightConditions = [
    { weight: 0.25, condition: '|S_I| ≥ 3' },
    { weight: 0.15, condition: '|S_I| = 2' },
    { weight: 0.05, condition: '|S_I| = 1' },
    { weight: 0, condition: '|S_I| = 0' },
  ];

  return (
    <div className={className} style={style}>
      <MathMLRenderer mathML={introMath} />
      <MathMLRenderer mathML={setDefinition} />
      <MathMLRenderer mathML={subsetDefinition} className="pl-4" />
      <WeightTable variable="I" conditions={weightConditions} />
    </div>
  );
};